import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_3"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 10 201.7 149"
    style={{
      enableBackground: "new 0 10 201.7 149",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:none;stroke:" + strokeColor + ";stroke-width:0.6;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000009589858082723009400000005407064561265851264_);fill:none;stroke:" + strokeColor + ";stroke-width:0.6;stroke-miterlimit:10;}\n"
      }
    </style>
    <g>
      <g>
        <path
          className="st0"
          d="M42.7,15c0,0.2-0.1,0.3-0.1,0.5c-0.5,1.9-0.9,3.6-1.1,4.7c-0.4,1.8-1.5,6-2.8,11c-2.2,8.1-4.8,18.2-5.5,22.5 c-0.4,2.8-1.5,7.3-2.5,12C29,72.4,27.3,80,26.9,84.2l0,0c0,0-0.6,1.4-1.4,3.7c-1.2,3.6-2.6,9.1-2.6,15.1c0,4.8,0.2,14.2,1.4,23.5 c1.5,11.4,4,19.1,7.5,22.7l0,0c0.4,0.5,0.9,0.8,1.3,1.1l0,0c0.2,0.3,0.4,0.5,0.5,0.7c0.4,0.6,0.4,0.6,1.8,1l0.3,0.1 c1.9,1.5,6.7,2.2,14.6,2.2h107.2c9.1,0,14.9-1.4,17.2-4c4.1-4.7,6.6-15.2,7.9-23.2c1.6-9.2,2.3-19,2.3-24.2 c0-9.6-4.5-18.1-4.7-18.6l0,0l0,0v-0.1c-0.4-4.2-2.9-10.8-5.4-17.3c-1.7-4.4-3.3-8.6-4-11.6c-1.2-4.8-7.8-32.1-9.3-36.8 c-0.4-1.3-0.8-2.5-1.2-3.7"
        />
      </g>
      <g>
        <path
          className="st0"
          d="M56.2,96.9L56.2,96.9c0,0,16.6,7.3,49.4,7.3s44.8-6.8,44.8-6.8h0.2"
        />
      </g>
      <g>
        <g>
          <g>
            <path
              id="SVGID_1_"
              className="st0"
              d="M156,22.4c2.8,3.2,12,32.9,12,32.9s-31.1-3-66-3s-66,2.6-66,2.6c0.1-0.8,7.9-30.6,13.9-33.8"
            />
          </g>
        </g>
        <path
          className="st0"
          d="M157.3,24.6c3.6,7.6,10.3,29.6,10.7,30.7v0.1h-0.1c-0.3,0-31.5-3-66-3S36.2,55,35.9,55h-0.1v-0.1 c0.1-0.4,2-8,4.7-16c2.1-6.2,5-13.6,7.8-16.6"
        />
      </g>
      <g>
        <g>
          <g>
            <path
              id="SVGID_00000140000109474877077080000006966853409466085003_"
              className="st0"
              d="M171.5,55.4c-0.1-1.1,3.2-6.4,6.3-6.7 c3.2-0.2,15.2,2.2,16.9,4.8c1.6,2.6,1.4,9.5-3,11.3c-4.5,1.8-15,2-16.8,0.7C173.2,64.2,171.9,61.1,171.5,55.4z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <defs>
                    <path
                      id="SVGID_00000003792472899867504560000004824481235062121601_"
                      d="M32.6,55.4c0.1-1.1-3.2-6.4-6.3-6.7 c-3.2-0.2-15.2,2.2-16.9,4.8c-1.6,2.6-1.4,9.5,3,11.3c4.5,1.8,15,2,16.8,0.7C31,64.2,32.3,61.1,32.6,55.4z"
                    />
                  </defs>
                  <clipPath id="SVGID_00000025439968616148411380000014557999719724655008_">
                    <use
                      xlinkHref="#SVGID_00000003792472899867504560000004824481235062121601_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <polygon
                    style={{
                      clipPath:
                        "url(#SVGID_00000025439968616148411380000014557999719724655008_)",
                      fill: "none",
                      stroke: strokeColor,
                      strokeWidth: 0.6,
                      strokeMiterlimit: 10,
                    }}
                    points=" 32.7,52.6 26.7,48.4 32.7,48.4  "
                  />
                  <use
                    xlinkHref="#SVGID_00000003792472899867504560000004824481235062121601_"
                    style={{
                      overflow: "visible",
                      fill: "none",
                      stroke: strokeColor,
                      strokeWidth: 0.6,
                      strokeMiterlimit: 10,
                    }}
                  />
                </g>
              </g>
              <g>
                <path
                  id="SVGID_00000072253892478663889070000006360305022365105282_"
                  className="st0"
                  d="M32.6,55.4c0.1-1.1-3.2-6.4-6.3-6.7 c-3.2-0.2-15.2,2.2-16.9,4.8c-1.6,2.6-1.4,9.5,3,11.3c4.5,1.8,15,2,16.8,0.7C31,64.2,32.3,61.1,32.6,55.4z"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              id="SVGID_00000181788859038223552730000009814629664366435228_"
              className="st0"
              d="M32.6,55.4c0.1-1.1-3.2-6.4-6.3-6.7 c-3.2-0.2-15.2,2.2-16.9,4.8c-1.6,2.6-1.4,9.5,3,11.3c4.5,1.8,15,2,16.8,0.7C31,64.2,32.3,61.1,32.6,55.4z"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="Layer_2">
      <path
        className="st0"
        d="M54.9,94.1c-2.1-3.6-5.9-10.4-7.4-12.2c-1.9-2.4-6.3-5-8.6-5.8c-1.8-0.6-6.5-2.3-9-2.3c-0.5,0-1.1,0-1.2,0.3 c-0.3,1.9-1.5,7.8-1.5,7.8c0.3,3.8,0.6,10.7,3.5,13c2.8,2,22.3,2.5,24.6,2.6c0.1,0,0.6-0.1,0.8-0.5c0.1-0.2,0.1-0.5-0.1-0.9 C55.9,96,55.4,95.1,54.9,94.1z"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M151,97.5c-0.1,0-0.6-0.1-0.8-0.5c-0.1-0.2-0.1-0.5,0.1-0.9c0.1-0.1,0.6-1,1.1-2c2.1-3.6,5.9-10.4,7.4-12.2 c1.9-2.4,6.3-5,8.6-5.8c1.8-0.6,6.5-2.3,9-2.3c0.5,0,0.8,0,0.9,0.3c0.3,0.9,1.6,5,2.2,7.2c1,3.7-0.9,11.4-3.9,13.6 C172.8,96.9,153.3,97.4,151,97.5L151,97.5L151,97.5z"
      />
    </g>
  </svg>
);
export default SvgComponent;


